module.exports = "img/flags/BH.29d16f5.png";